import { useEffect, useState } from 'react';

type TUseTimer = {
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
};

const DAYS_IN_MS = 1000 * 60 * 60 * 24;
const HOURS_IN_MS = 1000 * 60 * 60;
const MIN_IN_MS = 1000 * 60;
const SEC_IN_MS = 1000;

const getTimeDiff = (diffInMSec: number): TUseTimer => {
  let diff = diffInMSec;
  const days = Math.floor(diff / DAYS_IN_MS);
  diff -= days * DAYS_IN_MS;
  const hours = Math.floor(diff / HOURS_IN_MS);
  diff -= hours * HOURS_IN_MS;
  const minutes = Math.floor(diff / MIN_IN_MS);
  diff -= minutes * MIN_IN_MS;
  const seconds = Math.floor(diff / SEC_IN_MS);

  return {
    days: formatNumber(days),
    hours: formatNumber(hours),
    minutes: formatNumber(minutes),
    seconds: formatNumber(seconds),
  };
};

const formatNumber = (num: number) => {
  return num < 10 ? `0${num}` : `${num}`;
};

type TimerType = TUseTimer & {timerReset: () => void, timeLeftMs: number};

export const useTimer = (targetTime: number): TimerType => {
  const [timeLeft, setTimeLeft] = useState(targetTime);

  useEffect(() => {
    const id = setTimeout(() => {
      // We can set conditions here like timeLeft > 0
      setTimeLeft((prev) => prev >= 1000 ? prev - 1000 : 0);
    }, 1000);

    return () => {
      clearTimeout(id);
    };
  });

  const timerReset = () => {
    setTimeLeft(targetTime);
  };

  return {
    ...getTimeDiff(timeLeft),
    timerReset,
    timeLeftMs: timeLeft,
  };
};
